<template>
  <ul>
    <li v-if="showBack" class="back" @click="_backPlay">
      <i></i>
    </li>
    <li
      v-if="barrageInfo.status === 1"
      id="barrage-skin"
      class="barrage"
      :class="{ 'z-active': showBarrage }"
      @click="_setBarrage"
    >
      <i>弹</i>
    </li>
  </ul>
</template>

<script>
import UserAgent from "@/utils/UserAgent/index";
import { mapGetters, mapMutations } from "vuex";

export default {
  props: {
    mps: {}
  },
  data() {
    return {
      showBarrage: true
    };
  },
  computed: {
    ...mapGetters({
      channelInfo: "channelInfo",
      playerInfo: "playerInfo"
    }),
    barrageInfo() {
      return this.channelInfo.barrageInfo;
    },
    showBack() {
      if (this.playerInfo.playUrl !== this.playerInfo.saveUrl) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.$Bus.$on("bus-sendBarrage", this._sendBarrage);
  },
  beforeDestroy() {
    this.$Bus.$off("bus-sendBarrage", this._sendBarrage);
  },
  methods: {
    ...mapMutations({
      set_playerInfo: "set_playerInfo"
    }),
    _backPlay() {
      let info = JSON.parse(JSON.stringify(this.playerInfo));
      info.playUrl = info.saveUrl;
      info.cameraId = "";
      this.set_playerInfo(info);
    },
    _setBarrage() {
      this.showBarrage = !this.showBarrage;
    },
    makeColor() {
      let colorArray = "0123456789abcdef";
      let color = "";
      for (let i = 0; i < 6; i++) {
        color += colorArray[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    _sendBarrage(str) {
      let content = str.replace(/(#)[\u4e00-\u9fa5A-Za-z0-9.]+(#)/gi, "");
      if (
        !this.mps ||
        !content ||
        !this.showBarrage ||
        this.barrageInfo.status !== 1
      ) {
        return false;
      }
      let fontColor = this.barrageInfo.fontColor || "FFFFFF";
      let fontSize = this.barrageInfo.fontSize || 2;
      let fontSpeed = this.barrageInfo.speed || 2;
      let color = fontColor === "random" ? this.makeColor() : fontColor;
      if (UserAgent.isMobile()) {
        let sizeArr = { "1": 12, "2": 16, "3": 22 };
        let speedArr = { "1": 50, "2": 30, "3": 10 };
        let size = sizeArr[fontSize] || 16;
        let speed = speedArr[fontSpeed] || 30;
        this.mps.sendbarrage2(
          content,
          size,
          "#" + color,
          "",
          speed,
          "微软雅黑"
        );
      } else {
        let sizeArr = { "1": 16, "2": 20, "3": 32 };
        let speedArr = { "1": 100, "2": 50, "3": 20 };
        let size = sizeArr[fontSize] || 16;
        let speed = speedArr[fontSpeed] || 50;
        this.mps.sendbarrage2(
          content,
          size,
          "#" + color,
          speed,
          "",
          "微软雅黑"
        );
      }
    }
  },
};
</script>

<style lang="less" scoped>
ul {
  width: 100%;
  li {
    margin-bottom: 5px;
    width: 50px;
    height: 50px;
    padding: 5px;
    text-align: center;
    font-size: 25px;
    i {
      display: inline-block;
      width: 40px;
      height: 40px;
      line-height: 40px;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.5);
    }
    &.back {
      i {
        background: url("./img/icon-back.png") no-repeat center center;
        background-size: 100% 100%;
      }
    }
    &.barrage {
      font-size: 20px;
      i {
        font-style: normal;
      }
      &.z-active {
        color: #008df6;
      }
    }
  }
}
</style>
